import React from 'react';
import LastUses from './LastUses';
import TariffUsageDetail from './TariffUsageDetail';
import PackageHeading from './PackageHeading';
import {gaEvent} from '../../../../utilities/analytics/tracking';
import gaParams from '../../../../utilities/analytics/constants';

const TariffPackage = ({thisPackage = null, isOverhead = false, isCurrentCycle = false, cycleStart=""}) => {
  const reportAnalyticTooltip = (isOverhead) => {
    if (isOverhead)
      gaEvent(gaParams.ABROAD_DATAUSAGES_TOOLTIPCLICK.category, gaParams.ABROAD_DATAUSAGES_TOOLTIPCLICK.eventType, 'שימושים בתעריף מזדמן');
    else
      gaEvent(gaParams.ABROAD_DATAUSAGES_TOOLTIPCLICK.category, gaParams.ABROAD_DATAUSAGES_TOOLTIPCLICK.eventType, 'שימושים בתעריף מוזל');
  };
  const reportAnalyticLastUse = (isOverhead) => {
    if (isOverhead)
      gaEvent(
        gaParams.ABROAD_DATAUSAGES_LASTUSESCLICK.category,
        gaParams.ABROAD_DATAUSAGES_LASTUSESCLICK.eventType,
        'שימושים בתעריף מזדמן'
      );
    else
      gaEvent(gaParams.ABROAD_DATAUSAGES_LASTUSESCLICK.category, gaParams.ABROAD_DATAUSAGES_LASTUSESCLICK.eventType, 'שימושים בתעריף מוזל');
  };
  const tooltipText = isOverhead ? (
    `
      <b>
        השימושים שביצעתם
        <br />
        שלא במסגרת חבילות חו"ל
      </b>
      <br />
      כאן מוצגים השימושים שבוצעו ואינם במסגרת חבילה או תוכנית בתעריף מוזל.
      <br />
      לידיעתכם, לא ניתן לגלוש ללא חבילת גלישה ולכן לא מוצגים כאן שימושי גלישה.
    `
  ) : (
    `
      <b>
        השימושים שביצעתם
        <br />
        במסגרת חבילות בתעריף מוזל
      </b>
      <br />
      <b>מתי תחויבו בתעריף מחו"ל?</b>
      <br />
      א. אם סיימתם את כמות הדקות או ההודעות במסגרת החבילה שרכשתם (המופיעה למעלה)
      <br />
      ב. אם ברשותכם תוכנית הכוללת דקות או הודעות בתעריף מחו"ל או גלישה יומית
    `
  );
  let returned = '',
    uses = '',
    lastUses = '';
  if (thisPackage != null) {
    if (thisPackage.usageDetails != null) {
      uses = thisPackage.usageDetails.map((u) => {
        return <TariffUsageDetail key={thisPackage.usageDetails.indexOf(u)} usageDetail={u} />;
      });
    }
    if (isCurrentCycle) {
      lastUses = (
        <LastUses
        cycleStart={cycleStart}
          onclick={() => {
            reportAnalyticLastUse(isOverhead);
          }}
          lastUsesArr={thisPackage.lastUses}
        />
      );
    }
    returned = (
      <div className='Package TariffPackage'>
        <PackageHeading
          text={isOverhead ? 'שימושים בתעריף מזדמן' : 'שימושים בתעריף מוזל'}
          tooltipId={
            isOverhead
              ? isCurrentCycle
                ? 'overheadTariffHeading_currentCycle'
                : 'overheadTariffHeading_previousCycle'
              : isCurrentCycle
              ? 'discountTariffHeading_currentCycle'
              : 'discountTariffHeading_previousCycle'
          }
          onclick={() => {
            reportAnalyticTooltip(isOverhead);
          }}
          tooltipText={tooltipText}
        />
        <div className='PackageBody'>
          {uses}
          {lastUses}
        </div>
      </div>
    );
  }
  return returned;
};

export default TariffPackage;
